import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M11 19a1.5 1.5 0 0 1-.7.41.27.27 0 0 0-.19.23L9.9 21.7a1.1 1.1 0 0 0 1.87.91l2.86-2.86a8.4 8.4 0 0 0 1.74-2.62 13.3 13.3 0 0 0 .39-3.22.26.26 0 0 0-.16-.25.28.28 0 0 0-.3.05Zm-6-6s2.52-2.54 5.3-5.32a.26.26 0 0 0 .05-.29.25.25 0 0 0-.25-.16 13.3 13.3 0 0 0-3.3.37 8.2 8.2 0 0 0-2.56 1.76l-2.85 2.85a1.1 1.1 0 0 0 .78 1.88l2.24-.27a.26.26 0 0 0 .22-.18A1.6 1.6 0 0 1 5 13m.62 3.85c-.9-.9-2.27-.75-3.41.38-.8.77-1.62 3.39-2.21 5.42a1.08 1.08 0 0 0 .27 1 1.1 1.1 0 0 0 1 .27c2-.56 4.6-1.39 5.4-2.19 1.14-1.13 1.29-2.5.38-3.4ZM23.36 0c-1.33.27-4 .9-4.85 1.73L6.35 13.93a.28.28 0 0 0 0 .38l3.36 3.35a.25.25 0 0 0 .37 0L22.26 5.49C23.09 4.65 23.72 2 24 .63a.52.52 0 0 0-.15-.47.53.53 0 0 0-.49-.16"
    }, null, -1)
  ]));
}
const interfaceShareRocket = { render };
export {
  interfaceShareRocket as default,
  render
};
//# sourceMappingURL=interface-share-rocket.svg.js.map
